import './App.css';
import NavBar from './components/Nav/NavBar';


function App() {
	return (
		<div className='App'>
			<NavBar />
		</div>
	);
}

export default App;
